import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { motion } from 'framer-motion';
export function PainPoints() {
  const painPoints = ['Hacés sándwiches ricos pero no sabés cuánto cobrar para ganar de verdad', 'El pan te queda seco en dos horas y no entendés por qué', 'Los rellenos se caen o quedan secos y sin sabor', 'No sabés cómo responder cuando un cliente pide precio por WhatsApp', 'Comprás ingredientes de más y tirás plata a la basura por el desperdicio', 'Querés vender para eventos pero no sabés cómo organizarte', 'El fin de semana cocinás mucho, vendés poco y el lunes empezás el mismo ciclo'];
  return <section className="py-14 bg-white" data-id="element-233">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-234">
        <div className="text-center mb-10" data-id="element-235">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-5 leading-tight" data-id="element-236">
            ¿Cuántos fines de semana más vas a trabajar sin ganar lo que
            mereces?
          </h2>
          <p className="text-lg md:text-xl text-brand-gray leading-relaxed mb-5" data-id="element-237">
            Tenés ganas de emprender. Sabés que los sándwiches de miga son un
            negocio que funciona. Pero nadie te dijo que ibas a pasar horas
            buscando recetas que no quedan bien, calculando precios a ojo y sin
            saber si realmente estás ganando o perdiendo plata.
          </p>
          <p className="text-xl md:text-2xl font-serif font-bold text-brand-gold" data-id="element-238">
            No es falta de talento. Es falta de un sistema.
          </p>
        </div>

        <div className="bg-brand-cream rounded-3xl p-6 md:p-8 border border-brand-lightGray shadow-sm" data-id="element-239">
          <h3 className="text-xl md:text-2xl font-bold text-brand-dark mb-5 text-center uppercase tracking-wide" data-id="element-240">
            LO QUE VIVÍS HOY SIN EL SISTEMA
          </h3>

          <div className="space-y-3 mb-8" data-id="element-241">
            {painPoints.map((point, idx) => <motion.div key={idx} className="flex items-start gap-4" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: idx * 0.1
          }} data-id="element-242">
                <div className="mt-1 bg-red-100 rounded-full p-1 flex-shrink-0" data-id="element-243">
                  <CloseIcon className="text-brand-red" fontSize="small" data-id="element-244" />
                </div>
                <p className="text-brand-dark font-medium text-lg" data-id="element-245">{point}</p>
              </motion.div>)}
          </div>

          <div className="text-center" data-id="element-246">
            <h4 className="text-2xl md:text-3xl font-serif font-bold text-brand-gold" data-id="element-247">
              ¿Y si este fuera el último fin de semana que pasás así?
            </h4>
          </div>
        </div>
      </div>
    </section>;
}